import EcommerceProductModel from "@/Interfaces/Product/EcommerceProductModel";
import { useShoppingCartStore } from "@/Stores/ShoppingCart/ShoppingCartStore";
import { storeToRefs } from "pinia";
import { router, useForm, usePage } from "@inertiajs/vue3";
import { ref } from "vue";

export const useShoppingCartComposable = () => {
    const shoppingStore = useShoppingCartStore();
    const { cartItems, localStorageCartItems, wishListItems, localStorageWishListItems, visibleRight } = storeToRefs(shoppingStore);

    const localStorageWishItems = ref<string|null>(null);
    const localStorageItems = ref<string|null>(null);
    const qtyInput = ref<number>(1);

    const form = useForm({
        cartItems: [] as EcommerceProductModel[]
    });

    const dbCartItems = usePage().props.flash?.cartItems;


    const getShopingCartItems = (product: EcommerceProductModel) => {
       
        const checkItem = cartItems.value.find((cartItem: EcommerceProductModel) => cartItem.id === product.id) as EcommerceProductModel;
        
        localStorageItems.value = localStorage.getItem('cartItems');
        localStorageCartItems.value = JSON.parse(localStorageItems.value!) as EcommerceProductModel[];
        
        if(localStorageItems.value !== null) {
            const checkItem = localStorageCartItems.value?.find((cartItem: EcommerceProductModel) => cartItem.id === product.id) as EcommerceProductModel;
            if (checkItem === undefined) {
                product.cart_qty = Number(qtyInput.value);
                localStorageCartItems.value?.push(product)
                localStorage.setItem('cartItems', JSON.stringify(localStorageCartItems.value));
            } else {
                
                checkItem.cart_qty = checkItem.cart_qty + Number(qtyInput.value);
                localStorage.setItem('cartItems', JSON.stringify(localStorageCartItems.value));
            }
        } else {
            
            if (checkItem === undefined) {
                product.cart_qty = Number(qtyInput.value);
                cartItems.value.push(product);
                localStorageCartItems.value?.push(product)
                localStorage.setItem('cartItems', JSON.stringify(cartItems.value));
            } else {
                
                checkItem.cart_qty = checkItem.cart_qty + Number(qtyInput.value);
                localStorage.setItem('cartItems', JSON.stringify(cartItems.value));
            }
        }

        form.cartItems = localStorageCartItems.value as EcommerceProductModel[];
        form.post(route('category.update-cart'), {
            preserveScroll: true,
            preserveState: true
        });
        
    }

    const makeWishList = (wishProduct: EcommerceProductModel) => {
        const checkItem = wishListItems.value.find((item: EcommerceProductModel) => item.id === wishProduct.id) as EcommerceProductModel;

        localStorageWishItems.value = localStorage.getItem('wishListItems');
        localStorageWishListItems.value = JSON.parse(localStorageWishItems.value!) as EcommerceProductModel[];

        if(localStorageWishItems.value !== null) {
            const checkItem = localStorageWishListItems.value?.find((wishListItems: EcommerceProductModel) => wishListItems.id === wishProduct.id) as EcommerceProductModel;
            if (checkItem === undefined) {
                wishProduct.cart_qty = 1;
                localStorageWishListItems.value?.push(wishProduct)
                localStorage.setItem('wishListItems', JSON.stringify(localStorageWishListItems.value));
            } else {
                
                checkItem.cart_qty = 1
                localStorage.setItem('wishListItems', JSON.stringify(localStorageWishListItems.value));
            }
        } else {
            
            if (checkItem === undefined) {
                wishProduct.cart_qty = 1;
                wishListItems.value.push(wishProduct);
                localStorageWishListItems.value?.push(wishProduct)
                localStorage.setItem('wishListItems', JSON.stringify(wishListItems.value));
            } else {
                
                wishListItems.cart_qty = 1;
                localStorage.setItem('wishListItems', JSON.stringify(wishListItems.value));
            }
        }
    }

    const checkOut = () => {
        router.visit(route('product.check-out'));
        visibleRight.value = false;
    }


    return { qtyInput, getShopingCartItems, makeWishList, checkOut }
}